import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import dayjs from 'dayjs';

function fullBorder() {
  return {
    top: { style: "thin", color: { rgb: "000000" } },
    bottom: { style: "thin", color: { rgb: "000000" } },
    left: { style: "thin", color: { rgb: "000000" } },
    right: { style: "thin", color: { rgb: "000000" } }
  };
}

function bottomBorder() {
  return {
    bottom: { style: "thin", color: { rgb: "000000" } }
  };
}

export function exportBillingExcel({ fullName, plateNo, dateRange, expenses }) {
  const start = dayjs(dateRange[0]).format("D/M/YYYY");
  const end = dayjs(dateRange[1]).format("D/M/YYYY");

  const sheet = [];

  sheet[1] = [];
  sheet[1][0] = {
    v: `${fullName}\n${plateNo}`,
    s: {
      font: { bold: true },
      alignment: { vertical: "center", horizontal: "center", wrapText: true }
    }
  };

  sheet[1][2] = {
    v: `${plateNo}\n${start} - ${end}`,
    s: {
      alignment: { vertical: "center", horizontal: "center", wrapText: true }
    }
  };

  const labelsB = [
    "ยอดวิ่งเดือน",
    "หักค่าตำรวจ",
    "ยอดติดลบเดือน",
    "หักค่าน้ำมัน",
    "อีซี่พาส",
    "PTT กสิกร",
    "PTT กรุงเทพ",
    "SHELL CARD",
    "หักค่าธรรมเนียมการโอนเงิน",
  ];

  for (let i = 0; i < labelsB.length; i++) {
    const row = i + 1;
    sheet[row] = sheet[row] || [];
    sheet[row][1] = {
      v: labelsB[i],
      s: {
        alignment: { vertical: "center", horizontal: "left" },
        font: {}
      }
    };
  }

  sheet[4] = sheet[4] || [];
  sheet[4][3] = {
    v: "2%",
    s: {
      alignment: { horizontal: "right" }
    }
  };

  sheet[4][4] = {
    f: "C5*0.02",
    s: {
      border: fullBorder(),
      alignment: { horizontal: "right" },
      numFmt: "#,##0.00"
    }
  };

  const rowStart = 2;
  expenses.forEach((e, i) => {
    const row = rowStart + i;
    sheet[row] = sheet[row] || [];
    sheet[row][4] = {
      v: e.amount,
      t: "n",
      s: {
        border: fullBorder(),
        alignment: { horizontal: "right" },
        numFmt: "#,##0.00"
      }
    };
  });

  sheet[12] = sheet[12] || [];
  sheet[12][4] = {
    f: "SUM(E3:E11)",
    s: {
      font: { bold: true },
      border: fullBorder(),
      alignment: { horizontal: "right" },
      numFmt: "#,##0.00"
    }
  };

  sheet[1][4] = {
    v: "",
    s: {
      border: fullBorder(),
      alignment: { horizontal: "right" },
      numFmt: "#,##0.00"
    }
  };

  sheet[12][1] = {
    v: "รวมค่าใช้จ่าย",
    s: {
      font: { bold: true },
      alignment: { vertical: "center", horizontal: "left" }
    }
  };

  sheet[13] = sheet[13] || [];
  sheet[13][1] = {
    v: "รายได้สุทธิ",
    s: {
      font: { bold: true },
      alignment: { vertical: "center", horizontal: "left" }
    }
  };

  sheet[13][4] = {
    f: "E2 - E13",
    s: {
      font: { bold: true },
      border: fullBorder(),
      alignment: { horizontal: "right" },
      numFmt: "#,##0.00"
    }
  };


  for (let r = 0; r < 14; r++) {
    for (let c = 0; c < 5; c++) {
      sheet[r] = sheet[r] || [];
      sheet[r][c] = sheet[r][c] || { v: "" };
      sheet[r][c].s = sheet[r][c].s || {};

      if (r === 0) {
        sheet[r][c].s.border = bottomBorder();
      } else {
        sheet[r][c].s.border = fullBorder();
      }
    }
  }

  const ws = XLSX.utils.aoa_to_sheet(sheet);

  ws["!merges"] = [
    { s: { r: 1, c: 0 }, e: { r: 3, c: 0 } },
    { s: { r: 1, c: 2 }, e: { r: 2, c: 2 } },
    { s: { r: 8, c: 0 }, e: { r: 13, c: 0 } },
    { s: { r: 11, c: 2 }, e: { r: 13, c: 3 } }
  ];

  ws["!cols"] = [
    { wch: 25 },
    { wch: 40 },
    { wch: 25 },
    { wch: 15 },
    { wch: 15 }
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "เบิกจ่าย");

  const buf = XLSX.write(wb, { type: "array", bookType: "xlsx" });
  saveAs(new Blob([buf]), "รายงานเบิกจ่ายรถซัพ.xlsx");
}
